import { useFetchTransactionsQuery } from '../transactionsApi';

export const useTransactions = (params = {}) => {
  return useFetchTransactionsQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      transactions: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};

